import {DomUtils} from "./util/DomUtils";
import {AsyncUtils} from "./util/AsyncUtils";

export const isLocalEnvironment = () => {
    return DomUtils.getMetaContents("serverEnvironment") === "localhost";
}

export const isProductionEnvironment = () => {
    return DomUtils.getMetaContents("serverEnvironment") === "production";
}

export const openLiveChat = () => {

    // livechat script already loaded
    if (typeof phplive_launch_chat_0 === 'function') {
        eval("phplive_launch_chat_0()");
    } else {

        AsyncUtils.loadScriptAsync("//livechat.iccsafe.org//js/phplive_v2.js.php?v=0|1440692297|1|").then(() => {

            // cannot assume script all been parsed yet - wait until this variable is seen
            AsyncUtils.awaitUntil(() => {
                return typeof phplive_launch_chat_0 === 'function' && typeof phplive_jquery === 'function';
            }, 100).then(() => {
                eval("phplive_launch_chat_0()");
            });

        });
    }
}

export const openTidioLiveChat = () => {

    const getTidioScriptUrl = () => {
        if (isLocalEnvironment()) {
            return "https://code.tidio.co/ngstieotawkotyrw4oamkhspscktkelk.js";
        }
        return "https://code.tidio.co/k8t1fnmfe1rywpbfgugd4cxoref1bwji.js";
    }

    if (typeof window.tidioChatApi === 'undefined') {

        document.addEventListener("tidioChat-ready", () => {
            window.tidioChatApi.display(true);
            //window.tidioChatApi.open();
        });

        AsyncUtils.loadScriptAsync(getTidioScriptUrl()).then(() => {
            // should trigger event above
        });

    } else {
        window.tidioChatApi.display(true);
        //window.tidioChatApi.open();
    }
}

/**
 * @param {string} text
 * @param {'success' | 'info' | 'warning' | 'error' | 'primary' | 'secondary'} type
 */
export const showNotification = (text, type) => {

    if (typeof EventBus !== 'undefined') {
        EventBus.fire('notification', {
            text: text,
            type: type
        });
    }
}

// ignore errors when decoding invalid base64
export const base64DecodeSafe = (encodedData, fallbackValue = null) => {

    try {
        return atob(encodedData);
    } catch (e) {
        console.error(e);
    }

    return fallbackValue;
}

export const jsonParseQuietly = (text, fallbackValue = null) => {

    try {
        return JSON.parse(text);
    } catch (e) {
        return fallbackValue;
    }
}